module.exports = "/_next/static/files/91aecb68465f8e16221e82fc08e48e24.svg";